export default "__VITE_PUBLIC_ASSET__08431fc8__"